import React, { PureComponent, Fragment } from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import SurveyCreate from './SurveyWizardNew/components/SurveyCreate'

import '../assets/css/emDistribute.css'
import Panel from '../UniformComponents/Panel'

@observer
class EmDistribute extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            mailTo: '',
            surveyUser: null,
            errorState: false,
        }
    }

    async componentDidMount() {
        const { store } = this.props
        const { id } = store.survey
        const surveyUser = await store.http.get(`/surveyusers/${id}?top=20&start=0&sdstatus=&optedout=false&invalid=false&type=1,-1&filter=`)
        this.setState({ surveyUser: surveyUser.data[0].surveyuserid_txt })
    }

    openSurvey = (url) => {
        window.open(url, '_blank')
    }

    copyToClipboard = (text) => {
        const { store } = this.props
        navigator.clipboard.writeText(text).then(() => {
            store.addNotification(null, 'Copied to clipboard', 'success')
        })
    }

    sendEmail = async (surveyURL) => {
        const { store } = this.props
        const { mailTo } = this.state

        const body = {
            subject: i18n.t('distribute.MAXBI.emailSubject'),
            body: `<span style="display: none !important; visibility: hidden; mso-hide: all; font-size: 1px; color: ##ffffff; line-height: 1px; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden;"></span>
            <br /><table border="0" cellspacing="0" cellpadding="0" width="100%"><tr><td align="center"><table border="0" cellspacing="0" cellpadding="0" width="550"><tr><td align="center"></td></tr><tr><td align="left"><br> 
            <span style="display:block;font-family:'arial';font-size:14px;">Hi,<br> <br> ${i18n.t('distribute.MAXBI.emailBody', { 1: surveyURL })}<br> <br> <br> <br> Explori</span> 
            <br><br><br></td></tr></table></td></tr><tr><td align="center">
            <br /><p style="font-size: 8px;">Explori Media Ltd. is a company registered in England &amp; Wales under number 07723321.<br />Registered office: 5th Floor, Corinthian House, 17 Lansdowne Road, Croydon, England, CR0 2BX</p></td></tr></table>`,
            to: [mailTo],
        }

        try {
            await store.http.post('/sendEmail', JSON.stringify(body))
            store.addNotification(null, 'Email Sent', 'success')
        } catch (e) {
            console.log(e)
        }
    }

    spinner = () => {
        if (this.state.errorState) {
            return <div className="spinner">There has been an error</div>
        }
        return <div className="spinner"><img alt="spinner" src={`${process.env.CDN_URL}/includes/images/loading.svg`} /></div>
    }

    render() {
        const { store } = this.props
        const { survey } = store
        const { showBranchBanner } = survey
        const { surveyUser } = this.state
        const surveyURL = store.survey.getUserLink(surveyUser, true)
        const isNewHeader = process.env.USE_NEW_HEADER_UI
        return (
            <Fragment>
                <div style={{ paddingTop: isNewHeader ? '78px' : '20px' }} className={`${showBranchBanner ? 'branching' : ''} survey-view-wrapper`}>
                    <Panel style={{ width: '100%' }}>
                        <div style={{ float: 'none' }}>
                            {surveyUser ? (
                                <Fragment>
                                    <div style={{ width: '100%', textAlign: 'center' }}>
                                        <h2>{i18n.t('surveyWizard.stage.EM.2.title', 'Complete Maxbi entry')}</h2>
                                        <h4>{i18n.t('surveyWizard.stage.EM.2.desc', 'Choose from the following options')}</h4>
                                    </div>

                                    <br />

                                    <SurveyCreate
                                        wizardStore={{
                                            surveyType: 'EM',
                                            initSurveyCreate: () => undefined,
                                            surveyCreateLoading: false,
                                            surveyOptionEnum: {
                                                BLANK_SURVEY: 5,
                                            },
                                            clientLocales: Object.keys(store.clientLocales),
                                            surveyOptions: [{
                                                id: 3,
                                                name: i18n.t('distribute.MAXBI.title'),
                                                color: 'green',
                                                icon: 'fa-light fa-check',
                                                onSelect: () => this.openSurvey(surveyURL),
                                                btnLabel: i18n.t('distribute.MAXBI.completeLabel'),
                                                isHide: () => false,
                                            },
                                            {
                                                id: 4,
                                                name: i18n.t('distribute.MAXBI.copySurvey'),
                                                color: 'red',
                                                icon: 'fa-light fa-clone',
                                                onSelect: () => this.copyToClipboard(surveyURL),
                                                btnLabel: i18n.t('distribute.MAXBI.copySurvey.button'),
                                                surveyUrl: surveyURL,
                                                isHide: () => false,
                                            }],
                                        }}
                                    />
                                </Fragment>
                            ) : this.spinner()}
                        </div>
                    </Panel>
                </div>
            </Fragment>
        )
    }
}

export default EmDistribute
